import { render, staticRenderFns } from "./FontSizeDropDownSelector.vue?vue&type=template&id=38914956&scoped=true&"
import script from "./FontSizeDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./FontSizeDropDownSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38914956",
  null
  
)

export default component.exports